/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * 1 = New
 * 2 = InProgress
 * 3 = Resolved
 * 4 = Declined
 * 5 = AwaitingFeedback
 */
export enum PlatformFeedbackStatus {
  New = 1,
  InProgress = 2,
  Resolved = 3,
  Declined = 4,
  AwaitingFeedback = 5
}
